module.exports = __webpack_public_path__ + "img/home_2.21c2d0a1.jpeg";